import { Action } from '@ngrx/store';

export enum ApiErrorsActionTypes {
  SET_GENERIC_API_ERROR = '[DataLayer] Set Generic Api Error',
  CLEAR_GENERIC_API_ERROR = '[DataLayer] Clear Generic Api Error',
}

export class SetGenericApiErrorCode implements Action {
  readonly type = ApiErrorsActionTypes.SET_GENERIC_API_ERROR;
  constructor(public payload: number) {}
}

export class ClearGenericApiErrorCode implements Action {
  readonly type = ApiErrorsActionTypes.CLEAR_GENERIC_API_ERROR;
}

export type ApiErrorsAction = SetGenericApiErrorCode | ClearGenericApiErrorCode;
